import type { SxProps, Theme } from "@mui/material/styles";

export const timerLine: SxProps<Theme> = {
  textAlign: "center",
  mt: 2.75,
  mb: 3.25,
  fontSize: "0.8125rem",
  color: "text.secondary",
};

export const resendAction: SxProps<Theme> = {
  color: "primary.main",
  fontWeight: 600,
  cursor: "pointer",
  display: "inline",
};

export const phoneHighlight: SxProps<Theme> = {
  color: "text.primary",
  fontWeight: 600,
  direction: "ltr",
  display: "inline-block",
};

export const errorText: SxProps<Theme> = {
  textAlign: "center",
  mb: 1,
};
